import { PathOptions } from "leaflet";

export const neoenergia_pe_ssdat = (feature: any): PathOptions => {
  return {
    color: "#d78cff", // Purple, matching the 69 kV indicator in the Camadas panel
    weight: 2,
    opacity: 0.8,
  };
};
